import { GraphSchema } from '@ta/server';

export enum IdentityVerificationStatus {
  Pending = 0,
  Completed = 1,
  Failed = 2,
}

export interface IdentityVerification {
  id: string;
  status: IdentityVerificationStatus;
}

export const identityVerificationProps = new GraphSchema<IdentityVerification>(['id', 'status']);
